import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import controllerAusencias from "../ausencias/duck";
import { useSelector, useDispatch } from "react-redux";
import { responseSelector } from "../utils/helpers/selectors";
import moment from "moment";
import Loader from "../utils/Loader";
const { Text, Checkbox } = Inputs;
function AusenciasProfesionales({ history, match }) {
  const dispatch = useDispatch();

  const modelAusencias = useSelector((state) => state.getAusencias);
  const modelDeleteAusencia = useSelector((state) => state.deleteAusencia);
  const modelDeleteAusencias = useSelector((state) => state.deleteAusencias);
  const [profesionalFiltro, setProfesionalFiltro] = useState(null);
  const [diaFiltro, setDiaFiltro] = useState(null);
  const [ausencias, setAusencias] = useState([]);
  const [totalResultsAusencias, setTotalResultsAusencias] = useState(0);
  const [activePageAusencias, setActivePageAusencias] = useState(0);
  const [pageSizeAusencias, setPageSizeAusencias] = useState(10);
  const [arrayEliminar, setArrayEliminar] = useState([]);

  useEffect(() => {
    const data = modelDeleteAusencias?.data?.data;
    const error = modelDeleteAusencias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerAusencias.deleteAusenciasDuck.actions.clear());
    }
    if (data) {
      handlePageAusencias(0);
      dispatch(controllerAusencias.deleteAusenciasDuck.actions.clear());
    }
  }, [modelDeleteAusencias]);

  useEffect(() => {
    const data = modelDeleteAusencia?.data?.data;
    const error = modelDeleteAusencia?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerAusencias.deleteAusenciaDuck.actions.clear());
    }
    if (data) {
      handlePageAusencias(0);
      dispatch(controllerAusencias.deleteAusenciaDuck.actions.clear());
    }
  }, [modelDeleteAusencia]);

  useEffect(() => {
    const { data, error } = responseSelector(modelAusencias);

    if (error) {
      alert(error);
      dispatch(controllerAusencias.duck.actions.clear());
    }
    if (data) {
      setAusencias(data.items);
      setTotalResultsAusencias(data.total);

      dispatch(controllerAusencias.duck.actions.clear());
    }
  }, [modelAusencias]);

  useEffect(() => {
    dispatch(
      controllerAusencias.getAusenciasThunk(
        match.params.organizacion,
        1,
        pageSizeAusencias,
        profesionalFiltro,
        diaFiltro
      )
    );
  }, []);

  function handlePageAusencias(page) {
    setActivePageAusencias(page);
    setAusencias([]);
    setArrayEliminar([]);
    dispatch(
      controllerAusencias.getAusenciasThunk(
        match.params.organizacion,
        page + 1,
        pageSizeAusencias,
        profesionalFiltro,
        diaFiltro
      )
    );
  }

  function eliminarAusencia(id) {
    var answer = window.confirm(
      "¿Esta seguro que desea eliminar esta ausencia?"
    );
    if (answer) {
      dispatch(
        controllerAusencias.deleteAusenciaThunk({
          id,
        })
      );
    }
  }

  function eliminarAusencias() {
    var answer = window.confirm(
      "¿Esta seguro que desea eliminar las ausencias seleccionadas?"
    );
    if (answer) {
      dispatch(
        controllerAusencias.deleteAusenciasThunk({
          ids: arrayEliminar,
        })
      );
    }
  }

  function handleArrayAusencias(name, value) {
    if (value === true) {
      setArrayEliminar((arrayEliminar) => [...arrayEliminar, name]);
    } else {
      const newArray = arrayEliminar.filter((elem) => elem !== name);
      setArrayEliminar(newArray);
    }
  }
  return (
    <Content title="Local" subTitle="Local" browserTitle="Local" show={false}>
      <Row>
        <Col md="12">
          <Box title="Lista de ausencias">
            <Col md="12">
              <Col md="3">
                <label>Fecha de inicio</label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  customInput={<input type="text" className="form-control" />}
                  selected={diaFiltro}
                  onChange={(date) => {
                    setDiaFiltro(date);
                  }}
                  minDate={new Date()}
                />
              </Col>

              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Profesional"
                  value={profesionalFiltro}
                  onChange={(evt) => setProfesionalFiltro(evt.target.value)}
                />
              </Col>

              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePageAusencias(0)}
                  />
                </div>
              </Col>
            </Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() =>
                    history.push(
                      `/addAusencia/${match.params.organizacion}/${match.params.categoria}`
                    )
                  }
                />
              </div>
            </Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="danger"
                  text="Eliminar seleccionados"
                  pullRight={true}
                  onClick={() => eliminarAusencias()}
                />
                <div>
                  <span>Total: {totalResultsAusencias}</span>
                </div>
              </div>
            </Col>
            <Col md="12">
              <Loader
                isLoading={
                  modelDeleteAusencia.loading || modelAusencias.loading
                }
              >
                {ausencias && ausencias.length > 0 ? (
                  <SimpleTable
                    hover={true}
                    data={ausencias.map((row, index) => {
                      if (
                        match.params.categoria === "60f806a5e3e9af972fe85c7a"
                      ) {
                        return {
                          seleccion: (
                            <Checkbox
                              name={row._id}
                              onChange={(evt) =>
                                handleArrayAusencias(
                                  evt.target.name,
                                  evt.target.checked
                                )
                              }
                            />
                          ),
                          profesional: row.profesionalNombre,
                          fecha: moment(row.fecha, "YYYY-MM-DD").format(
                            "DD-MM-YYYY"
                          ),
                          eliminar: (
                            <Button
                              type="danger"
                              text="Eliminar"
                              onClick={() => eliminarAusencia(row._id)}
                            />
                          ),
                        };
                      } else {
                        return {
                          seleccion: (
                            <Checkbox
                              name={row._id}
                              onChange={(evt) =>
                                handleArrayAusencias(
                                  evt.target.name,
                                  evt.target.checked
                                )
                              }
                            />
                          ),
                          profesional: row.profesionalNombre,
                          fecha: moment(row.fecha, "YYYY-MM-DD").format(
                            "DD-MM-YYYY"
                          ),
                          inicio: row.horaInicio,
                          fin: row.horaFin,
                          eliminar: (
                            <Button
                              type="danger"
                              text="Eliminar"
                              onClick={() => eliminarAusencia(row._id)}
                            />
                          ),
                        };
                      }
                    })}
                    columns={
                      match.params.categoria === "60f806a5e3e9af972fe85c7a"
                        ? [
                            {
                              title: "Seleccion",
                              data: "seleccion",
                              width: "30px",
                            },
                            { title: "Ambiente", data: "profesional" },
                            { title: "Fecha", data: "fecha" },
                            { title: "Accion", data: "eliminar" },
                          ]
                        : [
                            {
                              title: "Seleccion",
                              data: "seleccion",
                              width: "30px",
                            },
                            { title: "Profesional", data: "profesional" },
                            { title: "Fecha", data: "fecha" },
                            { title: "Inicio", data: "inicio" },
                            { title: "Fin", data: "fin" },
                            { title: "Accion", data: "eliminar" },
                          ]
                    }
                  />
                ) : (
                  <Col md="12">
                    <h4>No se han encontrado resutlados</h4>
                  </Col>
                )}
              </Loader>
            </Col>
            <Pagination
              activePage={activePageAusencias}
              pageSize={pageSizeAusencias}
              totalElements={totalResultsAusencias}
              onChange={handlePageAusencias}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsAusencias}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AusenciasProfesionales;
